import { ChangeEvent, FunctionComponent, KeyboardEventHandler, useState } from "react";

type MileageInputProps = {
  id?: string;
  value: number | null;
  placeholder?: string;
  onChange: (value: number) => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  className?: string;
  autoFocus?: boolean;
  validationMessage?: string;
};

export const MileageInput: FunctionComponent<MileageInputProps> = ({
  id,
  value,
  placeholder,
  onChange,
  onKeyDown,
  className = "",
  autoFocus = false,
  validationMessage,
}) => {
  const formatNumber = (num: string) => num.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const cleanNumber = (num: string) => num.replace(/[^0-9]/g, "");

  const [formattedMileage, setFormattedMileage] = useState(
    formatNumber(cleanNumber(value?.toString() ?? "")),
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const cleaned = cleanNumber(e.target.value);
    setFormattedMileage(formatNumber(cleaned));
    onChange(parseInt(cleaned, 10));
  };

  return (
    <div className={`relative ${className}`}>
      <input
        id={id || "mileage"}
        name="mileage"
        className="w-full py-2 px-3 my-2 border border-neutral-500 rounded-md shadow"
        placeholder={placeholder}
        value={formattedMileage}
        autoFocus={autoFocus}
        onChange={handleChange}
        onKeyDown={onKeyDown}
      />
      <span className="absolute right-2 top-4 text-slate-300">km</span>
      {validationMessage && (
        <p className="mt-1 mb-4 text-sm text-error-600" id={`${id}-error`}>
          {validationMessage}
        </p>
      )}
    </div>
  );
};
